import { useEffect, useState } from "react";
import { useWriteContract, useWaitForTransactionReceipt } from "wagmi";
import { cronosMainnet } from "@/wagmi";
import { requestClaimVoucher, confirmClaim } from "@/api";

const CLAIM_ABI = [{
  type: "function", name: "claim", stateMutability: "nonpayable",
  inputs: [
    { name: "amount", type: "uint256" }, { name: "nonce", type: "uint256" },
    { name: "deadline", type: "uint256" }, { name: "signature", type: "bytes" },
  ],
  outputs: [],
}];

export function useFlameClaim({ address, flame, enabled, hasPendingVoucher, showToast, onDone, request = requestClaimVoucher, confirm = confirmClaim }) {
  const [voucher, setVoucher] = useState(null);
  const [preparing, setPreparing] = useState(false);
  const { writeContract, data: hash, isPending, error, reset } = useWriteContract();
  const receipt = useWaitForTransactionReceipt({ hash });

  useEffect(() => {
    if (!receipt.isSuccess || !hash) return;
    confirm(address, hash)
      .then((r) => { showToast(`${r.amount_claimed} FLAME claimed to your wallet`); setVoucher(null); reset(); onDone(); })
      .catch((e) => showToast(e?.response?.data?.detail || "Claim confirmation failed", "error"));
  }, [receipt.isSuccess]); // eslint-disable-line

  const claim = async () => {
    let v = voucher;
    if (!v) {
      setPreparing(true);
      try { v = await request(address); setVoucher(v); }
      catch (e) { setPreparing(false); return showToast(e?.response?.data?.detail || "Voucher failed", "error"); }
      setPreparing(false);
    }
    showToast("Sign the claim in your wallet (you pay gas)…");
    return writeContract({
      address: v.contract, abi: CLAIM_ABI, functionName: "claim", chainId: cronosMainnet.id,
      args: [BigInt(v.voucher.amount), BigInt(v.voucher.nonce), BigInt(v.voucher.deadline), v.signature],
    });
  };

  const busy = preparing || isPending || receipt.isLoading;
  const disabled = !enabled || busy || (!voucher && (flame <= 0 || hasPendingVoucher));
  const label = preparing ? "Preparing voucher…" : isPending ? "Confirm in wallet…" : receipt.isLoading ? "Confirming on-chain…" : voucher ? "Retry claim tx" : `Claim ${flame.toLocaleString()} FLAME`;
  return { claim, disabled, label, hash, error, voucher, busy };
}
